




























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import SerachSystemCode from '@/store/entities/sm/searchsystemcode'
import MailLists from '@/store/entities/rm/mailslist'
import CreateSystemCode from './create-systemcode.vue'
import UpdateSystemCode from './update-systemcode.vue'
@Component({
  components: { CreateSystemCode, UpdateSystemCode }
})
export default class MailList extends AbpBase {
  SerachSystemCode: SerachSystemCode = new SerachSystemCode()
  MailLists: MailLists = new MailLists()
  createsystemcodeshow: boolean = false
  updatesystemcodeshow: boolean = false
  wxgroupid: string = ''
  get list() {
    return this.$store.state.systemcode.list
  }
  get categorylist() {
    return this.$store.state.systemcode.categorylist
  }
  get loading() {
    return this.$store.state.systemcode.loading
  }
  async handleEdit(row) {
    await this.$store.dispatch('systemcode/GetSystemCode', { id: row.id })
    this.updatesystemcodeshow = true
  }
  createsyscode() {
    this.createsystemcodeshow = true
  }
  pageChange(page: number) {
    this.$store.commit('systemcode/setCurrentPage', page)
    this.getpage()
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit('systemcode/setPageSize', pagesize)
    this.getpage()
  }
  async getpage() {
    this.SerachSystemCode.maxResultCount = this.pageSize
    this.SerachSystemCode.skipCount = (this.currentPage - 1) * this.pageSize
    await this.$store.dispatch({
      type: 'systemcode/GetSystemCodeInfo',
      data: this.SerachSystemCode
    })
  }
  async getcategorydata() {
    await this.$store.dispatch({
      type: 'systemcode/GetSystemCodeCategoryInfo'
    })
  }
  async resetForm() {
    this.SerachSystemCode.keyword = ''
    this.getpage()
  }
  get pageSize() {
    return this.$store.state.systemcode.pageSize
  }
  get totalCount() {
    return this.$store.state.systemcode.totalCount
  }
  get currentPage() {
    return this.$store.state.systemcode.currentPage
  }
  async created() {
    this.getcategorydata()
    this.getpage()
  }
  mounted() {}
}
